export const NAME_FIELD_TEST_ID = 'nameField';
export const PHONE_FIELD_TEST_ID = 'phoneField';
export const EMAIL_FIELD_TEST_ID = 'emailField';
export const SUBMIT_BUTTON_TEST_ID = 'submitButton';

export const ERROR_LABEL_ROLE = 'errorLabel';

export const SUCCESS_MESSAGE_TEST_ID = 'successMessage';
export const ERROR_MESSAGE_TEST_ID = 'errorMessage';
